export default __webpack_public_path__ + "static/media/private_entrance.5be18b1c.svg";